import styled, { css } from 'styled-components'

type ServicesInfoProps = {
  darkTheme?: boolean
}

export const ServicesSection = styled.section<ServicesInfoProps>`
  padding: 2.5rem 0 4rem;
  ${({ darkTheme }) =>
    darkTheme &&
    css`
      background-color: #141723 !important;

      span,
      a,
      strong,
      h1,
      h2,
      h3,
      h4,
      button,
      p {
        color: #fff !important;
      }
    `}

  @media (max-width: 30rem) {
    padding: 2rem 0;
  }
`

export const ServicesReponsive = styled.div`
  @media (max-width: 76.25rem) {
    overflow-x: auto;
  }

  @media (max-width: 30rem) {
    width: 100%;
    overflow-x: auto;
    padding-bottom: 1.25rem;
  }
`

export const ServicesContainer = styled.div`
  display: flex;
  gap: 1.5625rem;
  max-width: 1310px;
  width: 100%;
  padding: 0px 1rem;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: 30rem) {
    gap: 1rem;

    &::after {
      content: '';
      flex-shrink: 0;
      width: 0.0063rem;
    }
  }
`

export const ServicesSubText = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  h3 {
    font-weight: 700;
    font-size: 1rem;
    line-height: 120%;
    color: #ffffff;
  }
  p {
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 140%;
    letter-spacing: 0;
    color: #ffffff;
    margin: 0.375rem auto 0;
  }

  @media (max-width: 30rem) {
    padding-top: 0.5rem;
  }
`

export const ServicesInfo = styled.div<ServicesInfoProps>`
  position: relative;
  padding: 0.5rem;
  z-index: 1;
  background: ${({ darkTheme }) =>
    darkTheme
      ? 'linear-gradient(180deg, #0250b5 -4.51%, #141723 104.58%)'
      : 'linear-gradient(89.74deg, #5C33FF 3.91%, #3399FF 98.18%)'};
  border-radius: 0rem 0rem 0.5rem 0.5rem;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 0.75rem;
  height: 6.125rem;

  @media (max-width: 30rem) {
    flex-direction: column;
    gap: 0;
    padding: 0.5rem 0.875rem;
    height: 7.625rem;
  }
`

export const ServicesImage = styled.div`
  overflow: hidden;
  height: 13.6875rem;
  width: 100%;
  border-radius: 0.5rem 0.5rem 0rem 0rem;
  position: relative;
  img {
    object-fit: cover;
    transform: scale(1);
    transition: all 0.3s;
  }

  @media (max-width: 30rem) {
    height: 10.5625rem;
  }
`

export const ServicesLink = styled.a`
  display: block;
  width: 100%;
  min-width: 17.5rem;

  &:hover {
    ${ServicesImage} {
      img {
        transform: scale(1.05);
        transition: all 0.3s;
      }
    }
  }

  @media (max-width: 75rem) {
    ${ServicesImage} {
      img {
        width: 100%;
      }
    }
  }
  @media (max-width: 30rem) {
    min-width: 15.5rem;
    height: auto;
    overflow: hidden;
  }
`
